import { render, staticRenderFns } from "./crudEmployee.vue?vue&type=template&id=52a67d3e&"
import script from "./crudEmployee.vue?vue&type=script&lang=js&"
export * from "./crudEmployee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports